export default {
  loginEndpoint: 'user/login',
  registerEndpoint: 'user',
  logout: 'user/logout',
  refreshEndpoint: 'user/refresh',
}
